/* eslint-disable camelcase */
import safeAccess from "safe-access";
import Device from "nexia_mobile/models/device";
import Group from "nexia_mobile/models/mixins/device_features/group";
import Sensor from "nexia_mobile/models/mixins/device_features/sensor";
import Url from "nexia_mobile/url";

export default class VognitionHomeProfile {
  constructor(location) {
    this.id = this._getIdFromUrl(location.get("id"));
    this.name = location.get("name");
    this.devices = [];

    location.get("devices").forEach((device) => {
      let deviceAttrs = this._getAttrsForModel(device);

      let addGroupMembers = device.hasFeature(Group);

      if (device.get("type") === "xxl_thermostat") {
        deviceAttrs.zones = [];

        if (addGroupMembers) {
          // add members to zones attribute
          device.getGroupMembers().forEach((zone) => {
            deviceAttrs.zones.push(this._getAttrsForModel(zone));
          });
          addGroupMembers = false;
        } else {
          // add single zone to zones attribute
          let zone = device.get("zones")[0];
          if (!zone) {
            // We are getting a rare error where we receive an empty zone (#152763626)
            zone = {};
          }
          zone = {
            name: device.get("name"),
            type: "xxl_zone",
            url: safeAccess(zone, "_links.self.href"),
            id: zone.id,
          };
          deviceAttrs.zones.push(zone);
        }
      }

      if (!_.contains(["group"], device.get("type"))) {
        this.devices.push(deviceAttrs);
      }

      if (addGroupMembers) {
        device.getGroupMembers().forEach((subDevice) => {
          this.devices.push(this._getAttrsForModel(subDevice));
        });
      }
    });

    location.get("automations").forEach((automation) => {
      this.devices.push(this._getAttrsForModel(automation, "automation"));
    });

    location.get("modes").forEach((mode) => {
      this.devices.push(this._getAttrsForModel(mode, "mode"));
    });

    // remove duplicates
    this.devices = _.uniq(
      this.devices,
      (device_info) => `${device_info.type}-${device_info.id}`
    );

    // remove anything that doesn't have an id
    this.devices = _.filter(this.devices, (item) => _.isFinite(item.id));
  }

  noDevices() {
    return !this.devices || this.devices.length < 1;
  }

  isEqual(profile) {
    return profile && JSON.stringify(profile) === JSON.stringify(this);
  }

  _getAttrsForModel(model, type = null) {
    let attrs = {
      name: model.get("name"),
      url: model.id,
      type: type || model.get("type"),
    };

    let id = this._getIdFromUrl(model.id);
    if (_.isNumber(id)) {
      attrs.id = id;
    }

    if (model instanceof Device) {
      if (model.hasFeature(Sensor)) {
        let sensors = [
          {
            type: this._normalizeSensorType(model.get("sensor_type")),
          },
        ];

        _.each(model.getSensorTypes(), (sensorType) => {
          return sensors.push({
            type: this._normalizeSensorType(sensorType),
          });
        });
        sensors = _.filter(sensors, (sensor) => Boolean(sensor.type));
        sensors = _.uniq(sensors, (sensor) => sensor.type);
        attrs.sensors = sensors;
      }
    }

    return attrs;
  }

  _getIdFromUrl(url) {
    let urlWithoutParams = Url.withoutParams(url) || "";
    return parseInt(safeAccess(urlWithoutParams.match(/\d+$/), "[0]"));
  }

  _normalizeSensorType(type) {
    return _.str.underscored(type);
  }
}



// WEBPACK FOOTER //
// ./src/vognition_home_profile.js